import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubSetupRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-setup',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/setup',
};
